import { apiRequest } from './api';

export const mailingApiService = {
  // Mailing listesi
  getMailings: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    const queryString = params.toString();
    return await apiRequest(`/marketing-management/mailing-planner/${queryString ? `?${queryString}` : ''}`, 'GET');
  },

  // Tek bir mailing
  getMailing: async (id) => {
    return await apiRequest(`/marketing-management/mailing-planner/${id}/`, 'GET');
  },

  // Yeni mailing oluştur
  createMailing: async (data) => {
    return await apiRequest('/marketing-management/mailing-planner/', 'POST', data);
  },

  // Mailing güncelle
  updateMailing: async (id, data) => {
    return await apiRequest(`/marketing-management/mailing-planner/${id}/`, 'PUT', data);
  },

  // Mailing sil
  deleteMailing: async (id) => {
    return await apiRequest(`/marketing-management/mailing-planner/${id}/`, 'DELETE');
  },

  // Referans verileri
  getMailingGoals: async () => {
    return await apiRequest('/marketing-management/mailing-goals/', 'GET');
  },

  getTargetMarkets: async () => {
    return await apiRequest('/marketing-management/target-markets/', 'GET');
  },

  getB2BB2COptions: async () => {
    return [
      { value: 'all', label: 'All' },
      { value: 'b2b', label: 'B2B' },
      { value: 'b2c', label: 'B2C' }
    ];
  },

  getStatusOptions: async () => {
    return [
      { value: 'ready', label: 'Hazır', color: 'green' },
      { value: 'in_progress', label: 'Yapılıyor', color: 'blue' },
      { value: 'pending', label: 'Beklemede', color: 'gray' }
    ];
  }
};

